module.exports = __webpack_public_path__ + "static/media/barandal-bridas.409b2fb2.jpg";